import React from 'react';
import { Input } from 'antd';
const TrackedLinkInput = () => React.createElement(Input, { placeholder: "Add tracked link", className: "promotion-input" });
export default TrackedLinkInput;
